import axios from "axios";
import { Message, MessageBox } from "element-ui";
// import qs from 'qs'
// import store from "../store";

axios.defaults.timeout = 1000000;
// 测试接口
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

//http request 拦截器
axios.interceptors.request.use(
  (config) => {
    // const token = Cookies.get("token")||'';
    // config.data = JSON.stringify(config.data);
    // config.headers = {
    //   // 'Content-Type':'application/x-www-form-urlencoded',
    //   "Content-Type": "application/json",
    //   // 'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
    //   "WEB-TOKEN": token,
    // };
    // config.headers['WEB-TOKEN']=token
    // if(token){
    //   config.params = {'WEB_TOKEN':token}
    // }
    return config;
  },
  (error) => {
    return Promise.reject(err);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  (response) => {
    // console.log(response)
    // console.log(response.data.code)
    if (response.data.code == "7001") {
      Message("请先登录");
      location.replace("/login");
      router.replace({
        path: "/login",
        query: {
          redirect: router.currentRoute.fullPath,
        },
      });
    }
    if (response.data.code == "7002") {
      // 黑名单
      MessageBox("您已被平台拉黑，请联系平台客服", {
        confirmButtonText: "确定",
        type: "error"
      }).then(() => {
        location.replace("/login");
        router.replace({
          path: "/login",
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
      });
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export default axios
